import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { PageBody } from '@uhg-abyss/web/ui/PageBody';

export const SearchContainer = styled('div', {
  margin: 15,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '18px',
  textAlign: 'left',
});
export const LocationSearchLabel = styled('label', {
  color: '#4B4D4F',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '16px',
  marginBottom: '10px',
});
export const SearchInputWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  paddingTop: '4px',
});

export const SearchInput = styled('input', {
  borderStyle: 'solid',
  borderWidth: '1px',
  borderRadius: '4px',
  width: '100%',
  fontSize: '$sm',
  backgroundColor: 'white',
  borderColor: '$core.color.neutral.60',
  lineHeight: '0px',
  appearance: 'none',
  resize: 'none',
  paddingLeft: '$sm',
  minHeight: '36px',
  color: '$neutralGray',
  variants: {
    error: {
      true: {
        borderColor: '#C40000',
        '&:focus': {
          borderColor: '#C40000',
          boxShadow: '0 0 0 2px #C40000',
        },
      },
    },
  },
});

export const ProviderSearchContainer = styled(PageBody, {
  textAlign: 'center',
  backgroundColor: 'white',
});

export const FindUserLocationContainer = styled('div', {
  alignSelf: 'flex-start',
});

export const StyledSearchButton = styled(Button, {
  '&.abyss-button-root': {
    padding: '0',
    '&:hover': { backgroundColor: 'transparent' },
  },
});
export const locationClearButton = {
  'abyss-button-root': {
    position: 'absolute',
    right: '2px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
};
export const StyledLocationError = styled('div', {
  marginTop: '4px',
});
